var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (annotation, artworks, category, disableEnd, disableStart, hasContext, isTouch, n, railId, title, undefined, viewAllUrl) {
buf.push("<div" + (jade.attr("data-rail", railId, true, true)) + " class=\"abrv-inner\"><div class=\"abrv-header\"><div>");
if ( annotation)
{
buf.push(null == (jade_interp = annotation) ? "" : jade_interp);
}
if ( category)
{
buf.push("<div class=\"abrv-category-annotation\">Category</div>");
}
if ( viewAllUrl)
{
buf.push("<a" + (jade.attr("href", viewAllUrl, true, true)) + "><h1>" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</h1></a>");
}
else
{
buf.push("<h1>" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</h1>");
}
buf.push("</div><div class=\"abrv-follow-button\"></div>");
if ( viewAllUrl)
{
buf.push("<a" + (jade.attr("href", viewAllUrl, true, true)) + " class=\"abrv-view-all\">View all</a>");
}
buf.push("</div><div class=\"abrv-content\"><div class=\"abrv-carousel mgr-horizontal-nav js-my-carousel\"><ul" + (jade.cls(['abrv-fillwidth-list','fillwidth-list','js-mgr-cells','mgr-cells',artworks ? '' : 'mgr-cells--loading'], [null,null,null,null,true])) + ">");
if ( hasContext)
{
buf.push("<li class=\"abrv-context mgr-cell abrv-fillwidth-row js-mgr-cell\"></li>");
}
if ( artworks && artworks.length)
{
// iterate artworks
;(function(){
  var $$obj = artworks;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

buf.push("<li class=\"mgr-cell abrv-fillwidth-row js-mgr-cell\"><div" + (jade.attr("data-id", artwork.id, true, true)) + " data-type=\"artwork\"" + (jade.attr("style", 'width: ' + (artwork.image.cell.width) + 'px', true, true)) + " class=\"artwork-brick artwork-brick--on-rail js-artwork-brick\"><div class=\"artwork-brick__image\"><a" + (jade.attr("href", artwork.href, true, true)) + "><img" + (jade.attr("src", artwork.image.cell.url, true, true)) + (jade.attr("alt", artwork.title, true, true)) + (jade.attr("width", artwork.image.cell.width, true, true)) + (jade.attr("height", artwork.image.cell.height, true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"artwork-brick__image__img\"></a><div" + (jade.attr("data-id", artwork.id, true, true)) + " class=\"artwork-brick__image__save js-artwork-brick-save-controls\"></div></div><div class=\"artwork-metadata-stub\">");
if ( artwork.cultural_maker)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.cultural_maker) ? "" : jade_interp)) + "</h4>");
}
else if ( artwork.artists && artwork.artists.length)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</h4>");
}
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-metadata-stub__title artwork-metadata-stub__line\"><em>" + (jade.escape(null == (jade_interp = artwork.title) ? "" : jade_interp)) + "</em>");
if ( artwork.date)
{
buf.push(", " + (jade.escape((jade_interp = artwork.date) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
if ( artwork.collecting_institution)
{
buf.push("<div class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.collecting_institution) ? "" : jade_interp)) + "</div>");
}
else if ( artwork.sale && artwork.sale.is_auction)
{
buf.push("<a" + (jade.attr("href", artwork.sale.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
else if ( artwork.partner)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
if ( artwork.sale_message && artwork.sale_message != 'Contact For Price' && !(artwork.sale && artwork.sale.is_auction))
{
buf.push("<div class=\"artwork-metadata-stub__sale-message artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</div>");
}
var auctionPartner = artwork.partner && (artwork.partner.type === 'Auction' || artwork.partner.type === 'Auction House')
if ( artwork.sale && artwork.sale.is_auction)
{
if ( artwork.is_sold)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\">Sold</div>");
}
else
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line artwork-metadata-stub__bid-now\">");
var sa = artwork.sale_artwork
if ( artwork.sale.is_live_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">Enter Live Auction</a>");
}
else if ( artwork.sale.is_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">");
var bids = sa.counts.bidder_positions
if ( bids > 0)
{
buf.push("" + (jade.escape((jade_interp = sa.highest_bid.display) == null ? '' : jade_interp)) + "&nbsp;" + (jade.escape(null == (jade_interp = '(' + bids + (bids > 1 ? ' bids' : ' bid') + ')') ? "" : jade_interp)));
}
else
{
buf.push("" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
}
else if ( artwork.sale.is_preview)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "</a>");
}
else if ( artwork.sale.is_closed)
{
buf.push("Auction closed");
}
buf.push("</div>");
}
}
else if ( artwork.is_inquireable && !artwork.is_acquireable)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\"><a" + (jade.attr("href", artwork.href, true, true)) + (jade.attr("data-artwork_id", artwork._id, true, true)) + " data-context_type=\"artwork feed item\" class=\"analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type.toLowerCase()) == null ? '' : jade_interp)) + "</a></div>");
}
buf.push("</div></div></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

buf.push("<li class=\"mgr-cell abrv-fillwidth-row js-mgr-cell\"><div" + (jade.attr("data-id", artwork.id, true, true)) + " data-type=\"artwork\"" + (jade.attr("style", 'width: ' + (artwork.image.cell.width) + 'px', true, true)) + " class=\"artwork-brick artwork-brick--on-rail js-artwork-brick\"><div class=\"artwork-brick__image\"><a" + (jade.attr("href", artwork.href, true, true)) + "><img" + (jade.attr("src", artwork.image.cell.url, true, true)) + (jade.attr("alt", artwork.title, true, true)) + (jade.attr("width", artwork.image.cell.width, true, true)) + (jade.attr("height", artwork.image.cell.height, true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"artwork-brick__image__img\"></a><div" + (jade.attr("data-id", artwork.id, true, true)) + " class=\"artwork-brick__image__save js-artwork-brick-save-controls\"></div></div><div class=\"artwork-metadata-stub\">");
if ( artwork.cultural_maker)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.cultural_maker) ? "" : jade_interp)) + "</h4>");
}
else if ( artwork.artists && artwork.artists.length)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</h4>");
}
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-metadata-stub__title artwork-metadata-stub__line\"><em>" + (jade.escape(null == (jade_interp = artwork.title) ? "" : jade_interp)) + "</em>");
if ( artwork.date)
{
buf.push(", " + (jade.escape((jade_interp = artwork.date) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
if ( artwork.collecting_institution)
{
buf.push("<div class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.collecting_institution) ? "" : jade_interp)) + "</div>");
}
else if ( artwork.sale && artwork.sale.is_auction)
{
buf.push("<a" + (jade.attr("href", artwork.sale.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
else if ( artwork.partner)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
if ( artwork.sale_message && artwork.sale_message != 'Contact For Price' && !(artwork.sale && artwork.sale.is_auction))
{
buf.push("<div class=\"artwork-metadata-stub__sale-message artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</div>");
}
var auctionPartner = artwork.partner && (artwork.partner.type === 'Auction' || artwork.partner.type === 'Auction House')
if ( artwork.sale && artwork.sale.is_auction)
{
if ( artwork.is_sold)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\">Sold</div>");
}
else
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line artwork-metadata-stub__bid-now\">");
var sa = artwork.sale_artwork
if ( artwork.sale.is_live_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">Enter Live Auction</a>");
}
else if ( artwork.sale.is_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">");
var bids = sa.counts.bidder_positions
if ( bids > 0)
{
buf.push("" + (jade.escape((jade_interp = sa.highest_bid.display) == null ? '' : jade_interp)) + "&nbsp;" + (jade.escape(null == (jade_interp = '(' + bids + (bids > 1 ? ' bids' : ' bid') + ')') ? "" : jade_interp)));
}
else
{
buf.push("" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
}
else if ( artwork.sale.is_preview)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "</a>");
}
else if ( artwork.sale.is_closed)
{
buf.push("Auction closed");
}
buf.push("</div>");
}
}
else if ( artwork.is_inquireable && !artwork.is_acquireable)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\"><a" + (jade.attr("href", artwork.href, true, true)) + (jade.attr("data-artwork_id", artwork._id, true, true)) + " data-context_type=\"artwork feed item\" class=\"analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type.toLowerCase()) == null ? '' : jade_interp)) + "</a></div>");
}
buf.push("</div></div></li>");
    }

  }
}).call(this);

}
if ( viewAllUrl)
{
buf.push("<li class=\"mgr-cell abrv-fillwidth-row js-mgr-cell\"><div class=\"abrv-fillwidth-row__view-all\"><a" + (jade.attr("href", viewAllUrl, true, true)) + " class=\"abrv-fillwidth-row__view-all__link\">View All</a></div></li>");
}
else
{
n = 0
while (n < 6)
{
n++
buf.push("<li class=\"mgr-cell mgr-cell--loading arv-fillwidth-row js-mgr-cell\"><div class=\"mgr-cell__image-placeholder\"></div><div class=\"mgr-cell__text-placeholder\"></div><div class=\"mgr-cell__text-placeholder\"></div><div class=\"mgr-cell__text-placeholder\"></div></li>");
}
}
buf.push("</ul>");
if ( artworks && artworks.length)
{
buf.push("<nav" + (jade.cls(['mgr-navigation','js-mgr-navigation',isTouch ? 'is-touch' : ''], [null,null,true])) + "><a" + (jade.attr("disabled", disableStart, true, true)) + " class=\"mgr-arrow-left\"><div class=\"mgr-arrow-icon icon-chevron-left js-mgr-prev\"></div></a><a" + (jade.attr("disabled", disableEnd, true, true)) + " class=\"mgr-arrow-right\"><div class=\"mgr-arrow-icon icon-chevron-right js-mgr-next\"></div></a></nav>");
}
buf.push("</div></div></div>");}.call(this,"annotation" in locals_for_with?locals_for_with.annotation:typeof annotation!=="undefined"?annotation:undefined,"artworks" in locals_for_with?locals_for_with.artworks:typeof artworks!=="undefined"?artworks:undefined,"category" in locals_for_with?locals_for_with.category:typeof category!=="undefined"?category:undefined,"disableEnd" in locals_for_with?locals_for_with.disableEnd:typeof disableEnd!=="undefined"?disableEnd:undefined,"disableStart" in locals_for_with?locals_for_with.disableStart:typeof disableStart!=="undefined"?disableStart:undefined,"hasContext" in locals_for_with?locals_for_with.hasContext:typeof hasContext!=="undefined"?hasContext:undefined,"isTouch" in locals_for_with?locals_for_with.isTouch:typeof isTouch!=="undefined"?isTouch:undefined,"n" in locals_for_with?locals_for_with.n:typeof n!=="undefined"?n:undefined,"railId" in locals_for_with?locals_for_with.railId:typeof railId!=="undefined"?railId:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"viewAllUrl" in locals_for_with?locals_for_with.viewAllUrl:typeof viewAllUrl!=="undefined"?viewAllUrl:undefined));;return buf.join("");
};
module.exports = template;